export default __webpack_public_path__ + "static/media/8.bd8ebd6d.jpg";